<div class="container-fluid">
    <div class="row">
        <div class="col-4 offset-4">
            <div class="d-flex flex-column flex-wrap gap-2 mt-3">
                    <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/kontrol'">Forsendelse</a>
                    <a class="btn btn-lg btn-outline-info" aria-current="page" [routerLink]="'/price-robot/products'">Prisrobot</a>
            </div>
        </div>
    </div>
</div>
